// Nature d'une facture — source unique partagée par la table desktop
// (InvoiceListPage), les cartes mobiles (InvoiceMobileCards) et l'écran admin
// (routes/admin/Invoices), sur le modèle de `invoiceStateLabels`.
//
// La nature est calculée côté API (`getInvoiceKinds`) à partir de la table qui
// référence la facture : contrats, frais de service (PRO_INVOICED_FEES) ou
// commission upsell (UPSELL_INVOICED_FEES). Les trois sont exclusives, avec la
// priorité `CONTRACTS > FEES_MONTHLY > FEES_UPSELL`.
//
// Les deux natures de frais DOIVENT rester distinguables : sur le PDF elles
// partagent le même émetteur et la même mention « acquittée », et seule cette
// étiquette les sépare dans une liste.

export type InvoiceKind = 'CONTRACTS' | 'FEES_MONTHLY' | 'FEES_UPSELL';

export const INVOICE_KIND_BADGES: Record<InvoiceKind, { label: string; className: string }> = {
  CONTRACTS: { label: 'Contrats', className: 'tw-bg-blue-100 tw-text-blue-700' },
  FEES_MONTHLY: { label: 'Frais mensualisation', className: 'tw-bg-amber-100 tw-text-amber-700' },
  FEES_UPSELL: { label: 'Frais Upsell', className: 'tw-bg-violet-100 tw-text-violet-700' },
};

/**
 * Repli sur « Contrats » : couvre une réponse d'API antérieure au champ
 * `invoiceKind`. Mieux vaut le type majoritaire qu'une cellule vide.
 */
export function getInvoiceKindBadge(kind: InvoiceKind | undefined) {
  return (kind && INVOICE_KIND_BADGES[kind]) || INVOICE_KIND_BADGES.CONTRACTS;
}

/**
 * Libellé seul, pour les écrans qui n'affichent pas de badge coloré.
 *
 * `contractsLabel` existe pour que les listes vendeur conservent leur formule
 * historique « Contrats & Services » sans dupliquer les libellés de frais, qui
 * eux ne doivent jamais diverger.
 */
export function getInvoiceKindLabel(
  kind: InvoiceKind | undefined,
  contractsLabel = INVOICE_KIND_BADGES.CONTRACTS.label,
): string {
  if (!kind || kind === 'CONTRACTS') return contractsLabel;
  return INVOICE_KIND_BADGES[kind].label;
}
